/** Energy — water usage report /energy/water-report (waterReport.vue) */
export default {
  waterReport: {
    dashboardTitle: 'Water report',
    tabStatistics: 'Tenant totals',
    tabDetail: 'Tenant detail',
    exportLoading: 'Exporting...',
    exportReport: 'Export',
    filterStatPeriod: 'Period',
    phDateStart: 'Start',
    phDateEnd: 'End',
    filterTenant: 'Tenant',
    phTenant: 'Select tenant',
    filterTenantType: 'Tenant type',
    tenantType0: 'Tenant',
    tenantType1: 'Common area',
    tenantType2: 'Other',
    tenantType3: 'Solar',
    btnReset: 'Reset',
    btnSelectAll: 'Select all',
    btnDeselectAll: 'Clear selection',
    tooltipDeviceDetail: 'Device detail is per tenant. With “All” selected, the first tenant in the list is used.',
    tooltipDetailDeviceDetail: 'Show device-level rows for the selected tenants',
    deviceDetailSwitch: 'Device detail',
    loadingText: 'Loading...',
    chartTrendTitle: 'Water usage trend',
    legendTotalFee: 'Total bill',
    legendTotalWater: 'Total volume',
    summaryTotalFee: 'Total bill',
    summaryTotalWater: 'Total volume',
    detailedData: 'Details',
    sectionDetailTitle: 'Tenant water detail',
    sectionDeviceDetailTitle: 'Tenant water detail by meter',
    colDate: 'Date',
    colWaterFeeYuan: 'Bill (CNY)',
    colWaterVolumeM3: 'Volume (m³)',
    colDevice: 'Device',
    colSettleWay: 'Settlement',
    colFee: 'Charge',
    colTime: 'Time',
    colCumulativeRead: 'Reading',
    colStartReading: 'Start reading',
    colEndReading: 'End reading',
    emptyNoData: 'No data',
    emptyNoDeviceDetail: 'No device-level rows',
    colTenantId: 'Tenant ID',
    colTenantName: 'Tenant name',
    colWaterMeter: 'Water meter',
    colDetail: 'Detail',
    colStatistics: 'Summary',
    colWaterFeeParen: 'Bill (CNY)',
    colWaterVolumeParen: 'Volume (m³)',
    tenantAll: 'All',
    summaryTotal: 'Total',
    dateSpan100Days: '100 days',
    dateSpan1Year: '1 year',
    msgDateRangeLimit: 'You can select at most {span}.',
    msgTenantListFail: 'Failed to load tenants',
    msgPickPeriod: 'Please select a period',
    msgPickTenant: 'Please select a tenant',
    msgNoTenantData: 'No tenant data',
    msgFetchFail: 'Failed to load data',
    msgExportEmpty: 'Nothing to export',
    msgExportEmptyDevice: 'No device detail to export',
    msgExportOk: 'Export completed',
    msgExportFail: 'Export failed',
    msgExportRetry: 'Try again',
    msgDeviceAutoTenant: 'First tenant selected for device detail',
    msgNoTenantAvailable: 'No tenants available',
    errNoDeviceExport: 'No device detail rows to export',
    errNoTenantMeterExport: 'No tenant water-meter detail rows to export',
    expFilterTime: 'Period: {start} – {end}',
    expFilterTenant: 'Tenants: {tenant}',
    expFilterDeviceDetail: 'Device detail',
    expColDate: 'Date',
    expColWaterFee: 'Bill (CNY)',
    expColWaterVolume: 'Volume (m³)',
    expColDevice: 'Device',
    expColSettleWay: 'Settlement',
    expColFee: 'Charge',
    expColRegion: 'Region tag',
    expColTenantId: 'Tenant ID',
    expColTenantName: 'Tenant name',
    expColWaterMeter: 'Water meter',
    expSheetStat: 'Tenant water totals',
    expSheetStatDevice: 'Tenant water by meter',
    expSheetDetail: 'Tenant water detail',
    expSheetDetailDevice: 'Tenant water detail by meter',
    listSep: ', ',
    seriesTotalFee: 'Total bill',
    seriesTotalWater: 'Total volume',
    yAxisWaterFee: 'Bill (CNY)',
    yAxisWaterVolume: 'Volume (m³)',
    unitYuan: 'CNY',
    settleWay0: 'Standard',
    settleWay1: 'Manual debit',
    settleWay2: 'System adjustment',
    settleWay3: 'Floating tariff',
    settleWay4: 'Shared allocation',
    settleWay5: 'Device debit',
    pickerYesterday: 'Yesterday',
    pickerThisWeek: 'This week',
    pickerLastWeek: 'Last week',
    pickerThisMonth: 'This month',
    pickerLastMonth: 'Last month',
    pickerLast3Months: 'Last 3 months',
    pickerLastYear: 'Last year'
  }
}
